import * as actions from "../actions";
import { endOfDay, startOfDay } from "date-fns";

const initialState = {
  startDate: startOfDay(new Date()).getTime(),
  endDate: endOfDay(new Date()).getTime(),
  vestigingIds: ["all"],
  vestigingen: [],
  item_type: [],
  item_type_list: ["all"],
  item_source_type: [],
  item_source_type_list: ["all"],
  item_names: [],
  item_names_list: ["all"],
  preOrderTimesIds: ["all"],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.HANDLE_DATE_CHANGE:
      return {
        ...state,
        [action.item]: action.date,
      };

    case actions.HANDLE_MULTISELECT:
      let oldState = { ...state };
      let selected = action.selected;

      const newSelected = selected.filter((x) => !oldState[action.item].includes(x));

      if (selected.indexOf("all") >= 0 && newSelected.indexOf("all") >= 0) {
        selected = ["all"];
      } else if (selected.indexOf("all") >= 0) {
        selected.splice(selected.indexOf("all"), 1);
      }

      return {
        ...state,
        [action.item]: selected,
      };

    default:
      return state;
  }
};

export default reducer;
